import { render } from "./LightboxWrapper.vue?vue&type=template&id=8fafb112&scoped=true"
import script from "./LightboxWrapper.vue?vue&type=script&lang=js"
export * from "./LightboxWrapper.vue?vue&type=script&lang=js"

import "./LightboxWrapper.vue?vue&type=style&index=0&id=8fafb112&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fafb112"]])

export default __exports__